module.exports = __webpack_public_path__ + "static/media/04-0203.4bb0f903.png";